import moment from 'moment'
export const transformed = (input)=>
    input?.split("-") // Split the string at the hyphen
        .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize the first letter of each word
        .join(" ");

export const  generateInitialsImage=(firstName, lastName) => {
    const canvas = document.createElement('canvas');
    canvas.width = 100;
    canvas.height = 100;
  
    const context = canvas.getContext('2d');
    context.fillStyle = '#000000'; // Set the text color
    context.fillRect(0, 0, canvas.width, canvas.height); // Fill the canvas with a black background
    context.fillStyle = '#ffffff'; // Set the font color
    context.font = '48px Arial'; // Set the font size and style
    context.textAlign = 'center';
    context.textBaseline = 'middle';
    const initials = firstName.charAt(0) + lastName.charAt(0); // Get the initials
    context.fillText(initials, canvas.width / 2, canvas.height / 2); // Draw the initials in the center
  
    const dataURL = canvas.toDataURL(); // Convert the canvas to a data URL
    const image = new Image();
    image.src = dataURL;
  
    // Append the image element to the document body or a specific container
    document.body.appendChild(image);
}

export const DateConverter =(date)=>moment(date).format('DD-MM-YYYY')